import { SvgIcon, SvgIconProps } from '@mui/material';

type Props = SvgIconProps;

const ChatIcon = (props: Props) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      {...props}
    >
      <path
        d="M9.5 0C14.7478 0 19 3.48854 19 7.79167C19 12.0948 14.7478 15.5833 9.5 15.5833C8.64591 15.5833 7.81923 15.4815 7.02909 15.3089C5.63149 16.15 3.61411 17 1.13954 17C0.683726 17 0.270841 16.7388 0.0921683 16.3315C-0.0865962 15.9242 -0.00033798 15.4549 0.307791 15.1362C0.331587 15.1185 1.34187 14.0516 2.08863 12.657C0.784663 11.3245 0 9.63333 0 7.79167C0 3.48854 4.25353 0 9.5 0ZM7.51779 13.1971C8.18462 13.3831 8.85144 13.4583 9.5 13.4583C13.5284 13.4583 16.8077 10.9172 16.8077 7.79167C16.8077 4.66615 13.5284 2.125 9.5 2.125C5.47163 2.125 2.19231 4.66615 2.19231 7.79167C2.19231 9.35 3.00118 10.501 3.67988 11.1961L4.75457 12.2984L4.03339 13.6398C3.87034 13.9055 3.68719 14.2508 3.49627 14.543C4.30514 14.3172 5.10168 13.9674 5.87812 13.4628L6.64086 13.0422L7.51779 13.1971Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default ChatIcon;
